import React, { useState, useEffect } from 'react';
import DesignForm from './DesignForm';
import DesignList from './DesignList';
import './MainDashboard.css';
import Navbar from '../common/Navbar';
import { useNavigate } from 'react-router-dom';
import { fetchUserStatus } from '../../services/accountService';
import TrialNotification from './TrialNotification';





function MainDashboard() {
  
  const navigate = useNavigate();
  const [userStatus, setUserStatus] = useState(null); // State to hold user's premium/trial status
  const [loadingUserStatus, setLoadingUserStatus] = useState(true);
  const [errorUserStatus, setErrorUserStatus] = useState(null);
  
  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const statusData = await fetchUserStatus();
        setUserStatus(statusData);
      } catch (err) {
        setErrorUserStatus('Failed to fetch user status.');
        console.error('Failed to fetch user status:', err);
      } finally {
        setLoadingUserStatus(false);
      }
    };
    fetchStatus();
  }, []);
  
  const handleDesignSelect = (designId) => {
    // Only navigate if user has access to interact with designs
    if (userStatus && (userStatus.is_premium || userStatus.is_trial_active)) {
      navigate(`/design/${designId}`);
    } else {
      // Provide more specific feedback based on status
      if (userStatus.has_pending_payment_proof) {
        alert('Your payment is currently under review. Please wait for verification to access premium features.');
      } else {
        alert('Access denied. Please upgrade to Premium or start a trial to access this feature.');
      }
      console.log('Access denied to design canvas. Please upgrade.');
    }
  };
  
  if (loadingUserStatus) {
    return <div className="main-dashboard-container">Loading user status...</div>;
  }

  if (errorUserStatus) {
    return <div className="main-dashboard-container error-message">{errorUserStatus}</div>;
  }
  
  // Determine if the user should have interactive access to designs
  const hasDesignInteractionAccess = userStatus && (userStatus.is_premium || userStatus.is_trial_active);
  
  return (
           <div className="main-dashboard-container">
               <aside className="dashboard-sidebar">
                   <div className="dashboard-header">
                       <h2>Design Infrastructure Tool</h2>
                   </div>
               </aside>
   
               <main className="dashboard-content">
                   <header className="design-list-header">
				   {userStatus && (
						<TrialNotification
							isPremium={userStatus.is_premium}
							isTrialActive={userStatus.is_trial_active}
							daysLeftInTrial={userStatus.days_left_in_trial}
							hasPendingPaymentProof={userStatus.has_pending_payment_proof}
						/>
					)}
					   <DesignList
							onDesignSelect={handleDesignSelect}
							hasDesignInteractionAccess={hasDesignInteractionAccess}
					   />
                   </header>
               </main>
   
               <aside className="dashboard-rightbar">
                   <Navbar />
               </aside>
           </div>
       );
}

export default MainDashboard;